import React, { memo, useState } from 'react'
import MenuBrowser from './MenuBrowser'
import { motion } from 'framer-motion'
import {
  Containers,
  WORLDWIDE_MENU_LINKS
} from '../../../domain/useCases/navBar/constants'
import { getNavBrowseAllProps } from '@/domain/useCases/navBar/getNavBrowseAllProps.ts'
import { NavSubItems } from './NavSubItems'
import { NavBrowseButton } from './NavBrowseButton'
const conVariants = {
  hidden: {
    opacity: 0,
    translateX: '300px',
    transition: {
      duration: 0.2,
      delay: 0.2
    }
  },
  animate: {
    opacity: 1,
    translateX: '0px',
    transition: {
      duration: 0.2
    }
  },
  exit: {
    opacity: 0,
    translateX: '300px',
    transition: {
      duration: 0.2
    }
  }
}

const LocationMenu = ({ setPage, page, setContainer }) => {
  const [state, setState] = useState({ open: null })
  const setOpen = (id) => {
    if (state.open === id) {
      setState({ open: null })
    } else {
      setState({
        open: id
      })
    }
  }
  const navButtonProps = getNavBrowseAllProps(Containers.WORLDWIDE)
  return (
    <motion.div
      variants={conVariants}
      initial="hidden"
      animate="animate"
      exit={{ x: -300, opacity: 0 }}
    >
      <div className="bg-white px-6 pb-12">
        <MenuBrowser setPage={setPage} />
        <div className="flex flex-col gap-y-6">
          <h2 className="flex items-center pt-4 !text-xl !font-medium leading-8 !text-gray-1100">
            Worldwide
          </h2>
          <ul className="flex flex-col gap-y-2">
            {Object.entries(WORLDWIDE_MENU_LINKS).map(([key, value]) => {
              return (
                <NavSubItems
                  page={page}
                  toggleOpen={setOpen}
                  label={key}
                  currentlyOpen={state.open}
                  items={value}
                  key={`${key}-menu`}
                />
              )
            })}
          </ul>
          <NavBrowseButton {...navButtonProps} />
        </div>
      </div>
    </motion.div>
  )
}

export default memo(LocationMenu)
